import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  orientationLocation: () =>
    i18n.t(i18nKeys.scheduleOrientationForm__orientationLocation),
  orientationLocationDisabled: () =>
    i18n.t(i18nKeys.scheduleOrientationForm__orientationLocationDisabled),
  availableOrientationsAt: () =>
    i18n.t(i18nKeys.scheduleOrientationForm__availableOrientationsAt),
  orientationHeldAt: () =>
    i18n.t(i18nKeys.scheduleOrientationForm__orientationHeldAt),
  orientationHeldAtDetails: () =>
    i18n.t(i18nKeys.scheduleOrientationForm__orientationHeldAtDetails),
  submitButton: () => i18n.t(i18nKeys.scheduleOrientationForm__submitButton),
  headerH1: () => i18n.t(i18nKeys.scheduleOrientationFormHeader__h1),
  headerText: () => i18n.t(i18nKeys.scheduleOrientationFormHeader__text),
  noOrientationH1: () => i18n.t(i18nKeys.noOrientation__h1),
  noOrientationText: () => i18n.t(i18nKeys.noOrientation__text),
}
